import { useState } from 'react';

export const moveArray = <T>(array: T[], from: number, to: number): T[] => {
  const newArray = array.slice();
  newArray.splice(
    to < 0 ? newArray.length + to : to,
    0,
    newArray.splice(from, 1)[0],
  );

  return newArray;
};

export const useMergeState = <T extends Record<string, any>>(initial?: T) => {
  const [state, setState] = useState(initial);

  const merge = (valueOrCallback: Partial<T> | ((value: T) => Partial<T>)) => {
    setState((oldVal) => {
      const newVal =
        valueOrCallback instanceof Function
          ? valueOrCallback(oldVal)
          : valueOrCallback;

      return { ...oldVal, ...newVal };
    });
  };

  return [state, merge, setState] as const;
};
